import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import * as Library from "../../../../utils/Library";
import FullScreenLoader from "../../../common/loaders/FullScreenLoader";
import FormContainer from "../../../common/forms/FormContainer";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/x-close.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/icons/download-01.svg";
import SimpleListComponent from "../../../common/lists/SimpleListComponent";
import Tooltip from "../../../common/tooltip/TooltipSimple";
import { getMappedStatus, getOrderSpanWithColor } from "../OrdersPage";

// #region SCOPED CSS
const StyledOrderPreview = styled.div`
    &.order-preview-container {
        color: var(--text-icons-gray-100);
        margin: 16px;
        width: 72vw;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: relative;
    }

    .order-preview-content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex: 1;
        overflow: hidden;
        position: relative;
    }

    .order-details-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }

    /* ====== ORDER ITEMS TABLE ====== */
    .order-items-table {
        display: flex !important;
        flex-direction: column;
        flex-shrink: 1;
        overflow: auto !important;
    }

    .first-section {
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .main-window-header {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 5px;
        padding: 0px 24px 0px 24px;
        display: flex;
        flex-direction: row;
        gap: 30px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-34 {
        padding: 15px 0px 15px 0px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-69 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-137 {
        display: flex;
        flex-direction: row;
        gap: 48px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-135 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        flex-shrink: 0;
    }
    .frame-136 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        flex-shrink: 1;
    }
    /* ====== UTILITY CLASSES FOR ORDER DETAILS (Consolidated from Figma) ====== */

    /* Section titles - FROM, TO, ORDER ID, etc. */
    .section-title {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
    }

    /* Transparent section title - invisible but maintains layout space */
    .section-title.transparent {
        opacity: 0;
    }

    /* Container for each label:value pair */
    .detail-item {
        text-align: left;
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        display: flex;
        flex-direction: row;
        gap: 4px;
        height: 20px;
    }

    /* Label text - gray color */
    .detail-label {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        white-space: nowrap;
    }

    /* Value text - blue color */
    .detail-value2 {
        color: var(--text-and-icons-blue-500, #00aeef);
        //max 2 lines then ellipsis
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    /* Warning variant for value text - orange color */
    .detail-value2.warning {
        color: var(--text-and-icons-orange-500, #ff9900);
    }

    .first-section .detail-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .first-section .detail-value {
        //white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    //media only when screen size is less than 1300px
    @media (max-width: 1350px) {
        .second-section .frame-137 {
            gap: 24px;
        }
    }

    //media only when screen size is less than 1024px
    @media (max-width: 1260px) {
        .second-section .frame-137 {
            gap: 12px;
        }
    }

    /* ====== BUTTON STYLES (kept from original Figma export) ====== */
    .btn-icon-swap {
        background: var(--buttons-all-platforms-gray-500, #10141b);
        border-radius: 4px;
        border-style: solid;
        border-color: var(--text-and-icons-gray-300, #4f5b6d);
        border-width: 1px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 120px;
        height: 35px;
        position: relative;
    }
    .btn-icon-swap.disabled {
        cursor: not-allowed;
        border-color: var(--text-and-icons-gray-300, #4f5b6d);
    }

    .btn-icon-swap.disabled ._3-imported {
        color: var(--text-and-icons-gray-300, #4f5b6d);
    }

    .frame-289 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .download-02 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .download-02.enabled {
        cursor: pointer;
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .download-02.disabled {
        cursor: not-allowed;
        color: var(--text-and-icons-gray-300, #4f5b6d);
    }
    ._3-imported {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: var(--button-text-small-font-size, 10px);
        letter-spacing: var(--button-text-small-letter-spacing, 0.0125em);
        font-weight: var(--button-text-small-font-weight, 400);
        text-transform: uppercase;
        position: relative;
    }

    /* ====== SECOND HEADER ROW CONTAINER ====== */
    .second-section {
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
`;
// #endregion

export default function OrderPreview({ onCloseClick, orderDetails }) {
    // #region VARS
    const [isLoading, setIsLoading] = useState(false);
    const [page] = useState(1);
    const [perPage] = useState(10000);
    const [orderPreviewData, setOrderPreviewData] = useState({});
    const [orderItems, setOrderItems] = useState([]);

    const orderPreviewRef = useRef(null);

    const columns = [
        {
            name: "EAN code",
            selector: row => row.barcode ?? "--",
            sortable: true,
            width: "130px"
        },
        {
            name: "Style name",
            selector: row => row.name ?? "--",
            width: "250px"
        },
        {
            name: "Style nr.",
            selector: row => row.styleNumber ?? "--",
            width: "150px"
        },
        {
            name: "Season",
            selector: row => row?.season ?? "--",
            width: "150px"
        },
        {
            name: "SKU",
            selector: row => row?.sku ?? row?.SKU ?? "--",
            width: "220px"
        },
        {
            name: "Gender",
            selector: row => row?.gender ?? "--",
            width: "130px"
        },
        {
            name: "Category",
            selector: row => row?.category ?? "--",
            width: "130px"
        },
        {
            name: "Product type",
            selector: row => row?.productType ?? "--",
            width: "130px"
        },
        {
            name: "Size",
            selector: row => row.size ?? "--",
            width: "130px"
        },
        {
            name: "Color",
            selector: row => row.colorName ?? "--",
            width: "130px"
        },
        {
            name: "Color code",
            selector: row => row.colorCode ?? "--",
            width: "130px"
        },
        {
            name: "Quantity",
            selector: row => row.quantity ?? "--",
            width: "130px"
        },
        {
            name: "Cost (excl.VAT)",
            selector: row => row.cost ?? "--",
            width: "130px"
        },
        {
            name: "RRP",
            selector: row => row.priceOUT ?? "--",
            width: "130px"
        }
    ];
    // #endregion

    // #region METHODS
    const fetchData = async () => {
        if (!orderDetails?._id) {
            Library.showToastMessage({
                message: "Order ID is required!",
                type: "error"
            });
            return;
        }

        const formData = {
            supplierOrderID: orderDetails?._id,
            page: page,
            limit: perPage
        };

        if (orderDetails) {
            const res = await Library.makeApiRequest({
                endpoint: "SupplierOrders/getSupplierOrderPreview",
                data: formData,
                setLoader: setIsLoading
            });

            if (res?.data?.status !== 200) return;
            const { supplierOrderData, supplierOrderItems } = res.data?.data || {};

            const mappedData = {
                supplier_name: supplierOrderData?.companyNameOfLabelBrand,
                brand_name: supplierOrderData?.labelBrandName,
                customer_name: supplierOrderData?.companyNameOfRetailBrand,
                store_name: supplierOrderData?.storeName,
                brand_customer_nr: supplierOrderData?.orderIDinStorePOS,
                order_nr: supplierOrderData?.orderNumber,
                order_id: supplierOrderData?.orderIdentifier,
                order_type: supplierOrderData?.orderType,
                order_date: supplierOrderData?.orderDate,
                order_status: supplierOrderData?.orderStatus,
                mapped_order_status: getMappedStatus(supplierOrderData?.orderStatus),
                delivery_window: supplierOrderData?.deliveryWindow,
                estimated_delivery_date: supplierOrderData?.estimatedDeliveryDate,
                collection_name: supplierOrderData?.collectionNames?.join(", "),
                collection_code: supplierOrderData?.seasonNames?.join(", "),
                season: supplierOrderData?.seasonNames?.join(", "),
                total_items: supplierOrderData?.totalItems,
                vat_percentage: supplierOrderData?.VATpercentage,
                vat_total: supplierOrderData?.VATtotal,
                currency: supplierOrderData?.currency,
                total_excl_vat: supplierOrderData?.totalPriceExcludingVAT,
                total_incl_vat: supplierOrderData?.totalPriceIncludingVAT,
                sku: supplierOrderData?.SKU,
                gender: supplierOrderData?.gender
            };

            setOrderPreviewData(mappedData);
            setOrderItems(supplierOrderItems);
        }
    };
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        fetchData();
    }, []);
    // #endregion

    // #region RENDER
    return (
        <>
            <FullScreenLoader isLoading={isLoading} isLoadingOverlay={true} />

            <StyledOrderPreview className="order-preview-container">
                <FormContainer
                    title="ORDERS FILE PREVIEW"
                    rightComponent={
                        <div className="cursor-pointer" onClick={onCloseClick}>
                            <CloseIcon />
                        </div>
                    }>
                    <div className="order-preview-content">
                        <div className="order-details-container" ref={orderPreviewRef}>
                            <div className="first-section">
                                <div className="main-window-header">
                                    <div className="frame-34">
                                        <div className="frame-69">
                                            <div className="frame-137">
                                                <DetailSection
                                                    title="FROM"
                                                    hiddenTitle={false}
                                                    items={[
                                                        {
                                                            label: "Supplier",
                                                            value: orderPreviewData?.supplier_name ?? "--"
                                                        },
                                                        {
                                                            label: "Brand",
                                                            value: orderPreviewData?.brand_name ?? "--"
                                                        }
                                                    ]}
                                                />

                                                <DetailSection
                                                    title="TO"
                                                    hiddenTitle={false}
                                                    items={[
                                                        {
                                                            label: "Customer",
                                                            value: orderPreviewData?.customer_name ?? "--"
                                                        },
                                                        {
                                                            label: "Store name",
                                                            value: orderPreviewData?.store_name ?? "--"
                                                        }
                                                    ]}
                                                />

                                                <DetailSection
                                                    title="TO"
                                                    hiddenTitle={true}
                                                    items={[
                                                        {
                                                            label: "Brand's Customer nr",
                                                            value: orderPreviewData?.brand_customer_nr
                                                        },
                                                        {
                                                            label: "Status",
                                                            value: orderPreviewData?.order_status
                                                                ? getOrderSpanWithColor(orderPreviewData?.order_status)
                                                                : "--"
                                                        }
                                                    ]}
                                                />

                                                {/* EMPTY RESERVED COLUMNS (for layout consistency) */}
                                                <div className="frame-136" />
                                                <div className="frame-136" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="btn-icon-swap disabled">
                                        <div className="frame-289">
                                            <DownloadIcon className="download-02 disabled" />
                                            <div className="_3-imported">EXPORT AS</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="second-section">
                                <div className="main-window-header">
                                    <div className="frame-34">
                                        <div className="frame-69">
                                            <div className="frame-137">
                                                <DetailSection
                                                    title="ORDER ID"
                                                    hiddenTitle={false}
                                                    items={[
                                                        { label: "Order nr", value: orderPreviewData?.order_nr },
                                                        { label: "Order ID", value: orderPreviewData?.order_id },
                                                        { label: "Order type", value: orderPreviewData?.order_type }
                                                    ]}
                                                />

                                                <DetailSection
                                                    title="ORDER TIMELINE"
                                                    hiddenTitle={false}
                                                    items={[
                                                        { label: "Order date", value: orderPreviewData?.order_date },
                                                        {
                                                            label: "Delivery window",
                                                            value: orderPreviewData?.delivery_window
                                                        },
                                                        {
                                                            label: "Estimated delivery date",
                                                            value: orderPreviewData?.estimated_delivery_date
                                                        }
                                                    ]}
                                                />

                                                <DetailSection
                                                    title="COLLECTION INFO"
                                                    hiddenTitle={false}
                                                    items={[
                                                        {
                                                            label: "Collection name",
                                                            value: orderPreviewData?.collection_name
                                                        },
                                                        {
                                                            label: "Collection code",
                                                            value: orderPreviewData?.collection_code
                                                        },
                                                        { label: "Season", value: orderPreviewData?.season }
                                                    ]}
                                                />

                                                <DetailSection
                                                    title="COLLECTION TOTALS"
                                                    hiddenTitle={false}
                                                    items={[
                                                        { label: "Total items", value: orderPreviewData?.total_items },
                                                        { label: "VAT%", value: orderPreviewData?.vat_percentage },
                                                        { label: "VAT total", value: orderPreviewData?.vat_total }
                                                    ]}
                                                />

                                                <DetailSection
                                                    title="TOTALS"
                                                    hiddenTitle={true}
                                                    items={[
                                                        { label: "Currency", value: orderPreviewData?.currency },
                                                        {
                                                            label: "Total excl VAT",
                                                            value: orderPreviewData?.total_excl_vat
                                                        },
                                                        {
                                                            label: "Total incl. VAT",
                                                            value: orderPreviewData?.total_incl_vat
                                                        }
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <SimpleListComponent
                            className="order-items-table w-100"
                            tableClassName="order-items-list w-100"
                            columns={columns}
                            listData={orderItems}
                            selectableRows={false}
                            pagination={false}
                            showHeader={false}
                            enabled={true}
                            fixedHeaderScrollHeight="calc(65vh - 160px)"
                        />
                    </div>
                </FormContainer>
            </StyledOrderPreview>
        </>
    );
    // #endregion
}

// #region SMALL COMPONENTS
const DetailItem = ({ label, value, warning = false, className = "" }) => {
    return (
        <div className={`detail-item ${className}`}>
            <span className="detail-label">{label}:&nbsp;</span>
            <Tooltip title={value}>
                <div className={`detail-value2 ${warning ? "warning" : ""}`}>{value ?? "--"}</div>
            </Tooltip>
        </div>
    );
};

// title + array of DetailItems
const DetailSection = ({ title, items, hiddenTitle = false }) => {
    return (
        <div className="frame-135">
            <div className={`section-title ${hiddenTitle ? "transparent" : ""}`}>{title}</div>
            {items.map((item, index) => (
                <DetailItem key={index} label={item.label} value={item.value} warning={item.warning} />
            ))}
        </div>
    );
};
// #endregion
